import { useLocation, useNavigate } from "react-router";
import TypeLogo from "../../assets/images/Bodybon-TypeLogo.png";
import Logo from "../../assets/images/Bodybon-Logo.png";
import Drawer from "./Drawer";
import useStore from "../../features/store";

const Navbar = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  //@ts-ignore
  const { profile } = useStore();

  return (
    <div
      className={`lg:max-w-[1300px] pt-3 mx-auto flex ${
        pathname === "/intro" || pathname === "/login"
          ? "justify-center"
          : "justify-between"
      } py-2 px-3 lg:px-0`}
    >
      {pathname === "/intro" ? (
        ""
      ) : pathname === "/login" ? (
        <img
          alt="بادی‌بان"
          src={TypeLogo}
          width={160}
          height={160}
          className="lg:mt-1 mt-5"
        />
      ) : (
        <div className="flex items-center">
          <img
            onClick={() => navigate("/")}
            alt="بادی‌بان"
            src={TypeLogo}
            className="w-[160px] cursor-pointer hidden lg:flex"
          />

          <img
            onClick={() => navigate("/")}
            alt="بادی‌بان"
            src={Logo}
            className="w-[40px] cursor-pointer flex lg:hidden"
          />
        </div>
      )}

      {pathname !== "/intro" && pathname !== "/login" && profile && <Drawer />}
    </div>
  );
};

export default Navbar;
